import { render, staticRenderFns } from "./DaemonConfigDetailsModal.vue?vue&type=template&id=3b1a9006&scoped=true"
import script from "./DaemonConfigDetailsModal.vue?vue&type=script&lang=js"
export * from "./DaemonConfigDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DaemonConfigDetailsModal.vue?vue&type=style&index=0&id=3b1a9006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a9006",
  null
  
)

export default component.exports